export default __webpack_public_path__ + "static/media/15788860445e1be39c5fd4b.7ce8ca0a.png";